import { Box, styled, Typography } from '@mui/material'

import { switcherSubheadingStyle } from 'common/styles'
import { RadioGroupOption } from 'elements/RadioGroup/interface'
import { concatToSXProp } from 'utils/style'

type FormControlLabelInnerProps = Pick<RadioGroupOption, 'label' | 'subheading'>

const StyledBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'withSubheading',
})<{ withSubheading: boolean }>(({ withSubheading }) => ({
  display: 'flex',
  flexDirection: 'column',
  ...(withSubheading && { paddingTop: '12px' }),
}))

export default function FormControlLabelInner({
  label,
  subheading,
}: FormControlLabelInnerProps): JSX.Element {
  const withSubheading = subheading !== undefined

  return (
    <StyledBox component="span" withSubheading={withSubheading}>
      <Typography component="span">{label}</Typography>
      {withSubheading && (
        <Typography
          variant="body2"
          component="span"
          sx={concatToSXProp(switcherSubheadingStyle, { paddingBottom: '12px' })}
        >
          {subheading}
        </Typography>
      )}
    </StyledBox>
  )
}
